var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { getGridStringOperators, gridStringOrNumberComparator } from '@mui/x-data-grid-premium';
import { upsertRatioBillingDetailsUrl } from "../../../api/url";
import { showSurface } from "../../../redux/awaitedSurfacesSlice";
import { showNotification } from "../../../redux/commonSlice";
import { getListAPI } from "../../../redux/crudSlice";
import { store } from "../../../store/store";
import { RatioBillingPopupComponent } from "../components/ratioBillingPopup";
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
var dispatch = store.dispatch;
/**
 * Wraps default string filter operators to work on object-valued fields. Use `valueFormatter` on column definition to format cell value to filter.
 * @param baseOperators - Default string filter operators (e.g. from getGridStringOperators)
 * @returns Filter operators compatible with object values
 */
export function filterOperatorsGenerator(baseOperators) {
    return baseOperators.map(function (operator) { return _objectSpread(_objectSpread({}, operator), {}, {
        getApplyFilterFn: function (filterItem, column) {
            var _operator$getApplyFil;
            var baseFn = (_operator$getApplyFil = operator.getApplyFilterFn) === null || _operator$getApplyFil === void 0 ? void 0 : _operator$getApplyFil.call(operator, filterItem, column);
            if (!baseFn)
                return null;
            return function (value, row, column, apiRef) {
                var _formatter;
                var formatter = column.valueFormatter;
                var formattedValue = (_formatter = formatter === null || formatter === void 0 ? void 0 : formatter(value, row, column, apiRef)) !== null && _formatter !== void 0 ? _formatter : value;
                return baseFn(formattedValue, row, column, apiRef);
            };
        }
    }); });
}
export var partLabourSearchSelectFilterOperators = filterOperatorsGenerator(getGridStringOperators());
export var searchSelectSortComparator = function (v1, v2, params1, params2) {
    var _api$getColumn;
    var api = params1.api;
    var col = api === null || api === void 0 || (_api$getColumn = api.getColumn) === null || _api$getColumn === void 0 ? void 0 : _api$getColumn.call(api, params1.field);
    var fv1 = api.getRowFormattedValue(api.getRow(params1.id), col);
    var fv2 = api.getRowFormattedValue(api.getRow(params2.id), col);
    return gridStringOrNumberComparator(fv1, fv2, params1, params2);
};
var saveRatioBillingDetails = function (ratioData, currentRow, headerServiceTypeId) { return __awaiter(void 0, void 0, void 0, function () {
    var _Response$payload, ratioDataBody, requestBody, Response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                ratioDataBody = ratioData.map(function (item, index) {
                    return {
                        ServiceTypeBillingRatioSettingId: item.ServiceTypeBillingRatioSettingId,
                        "HeaderServiceTypeId": headerServiceTypeId,
                        "LineServiceTypeId": currentRow.ServiceTypeId,
                        "EntityId": currentRow.EntityId,
                        "ChildId": currentRow.ChildId,
                        "Percentage": item.PercentageValue,
                        "IsChanged": false,
                        "ServiceTypeBillingRatioSettingSchemaId": item.SchemaId
                    };
                });
                requestBody = {
                    JobcardId: currentRow.JobCardId,
                    JobCardDetailBillingRatios: ratioDataBody
                };
                return [4 /*yield*/, dispatch(getListAPI({
                        key: '',
                        url: upsertRatioBillingDetailsUrl,
                        request: requestBody
                    }))];
            case 1:
                Response = _a.sent();
                if (Response !== null && Response !== void 0 && (_Response$payload = Response.payload) !== null && _Response$payload !== void 0 && (_Response$payload = _Response$payload.value) !== null && _Response$payload !== void 0 && _Response$payload.success) {
                    dispatch(showNotification({
                        isOpen: true,
                        message: "saved successfully.",
                        type: "success"
                    }));
                }
                return [2 /*return*/];
        }
    });
}); };
var handleOnSubmit = function (ratioData, rowData, headerServiceTypeId) { return __awaiter(void 0, void 0, void 0, function () {
    var totalPercent;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                totalPercent = 0;
                ratioData === null || ratioData === void 0 || ratioData.map(function (item) {
                    totalPercent += Number(item === null || item === void 0 ? void 0 : item.PercentageValue);
                });
                if (!(totalPercent === 100)) return [3 /*break*/, 2];
                return [4 /*yield*/, saveRatioBillingDetails(ratioData, rowData, headerServiceTypeId)];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                dispatch(showNotification({
                    isOpen: true,
                    message: "Ratio contribution must not exceed/less than 100%.",
                    type: "error"
                }));
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var handleRatioDetailsPopup = function (rowData, headerServiceTypeId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        dispatch(showSurface({
            type: 'Drawer',
            containerProps: {
                PaperProps: {
                    sx: {
                        padding: 2,
                        width: {
                            xs: '100%',
                            sm: '400px'
                        }
                    }
                },
                anchor: 'bottom',
                title: "Ratio billing"
            },
            Component: RatioBillingPopupComponent,
            componentProps: {
                onSubmit: function (ratioData) {
                    handleOnSubmit(ratioData, rowData, headerServiceTypeId);
                },
                rowData: rowData
            }
        }));
        return [2 /*return*/];
    });
}); };
export var checkModuleSectionUISettingMandatory = function (sectionKey) {
    var ModuleSection = getLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_JOBCARD) ? getLocalStorageItem(LOCAL_STORAGE_KEYS.MODULE_SECTION_JOBCARD) : [];
    var FoundModule = ModuleSection.find(function (item) { return item.Key === sectionKey; });
    if (FoundModule) {
        var _FoundModule$SectionA;
        var item = FoundModule === null || FoundModule === void 0 || (_FoundModule$SectionA = FoundModule.SectionAttributes) === null || _FoundModule$SectionA === void 0 ? void 0 : _FoundModule$SectionA.find(function (item) { return (item.Key === "MANDATORY" || item.Key === "OPTIONAL") && item.Value === 'ON'; });
        return !!item;
    }
    return false;
};
